<template>
  <div>
    <AlertBanner v-if="showBanner" class="w-full mt-0 sm:mt-32 lg:mt-0" :status="1"
      >Your email is already verified. Join Sittercity to view your review or find a sitter to help with your care needs.
    </AlertBanner>
    <div class="w-full max-w-488 mx-auto mt-32 pb-80 md:px-0 lg:mt-48">
      <Card v-if="loading" class="w-full p-24">
        <Spinner :width="96" :height="96" class="mx-auto my-192" />
      </Card>
      <div v-else>
        <VerificationSuccess v-if="emailVerified" />
        <GenericError
          v-else-if="showError"
          title="We couldn't verify your email"
          button-value="Contact Customer Success"
          button-href="https://support.sittercity.com/hc/en-us/requests/new"
        >
          There was an issue verifying your email. Try clicking the link in your email again or contact Customer Success with any
          questions.
        </GenericError>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import AlertBanner from '@/components/alert_banner/AlertBanner.vue';
import Card from '@/components/card/Card.vue';
import Spinner from '@/components/spinner/Spinner.vue';
import VerificationSuccess from './VerificationSuccess.vue';
import GenericError from '@/components/generic_error/GenericError.vue';
import { CONFIRM_EMAIL_MUTATION } from '@/graphql/ratings/mutations';

export default {
  name: 'EmailVerification',
  components: { AlertBanner, Card, Spinner, VerificationSuccess, GenericError },
  data() {
    return {
      loading: true,
      emailVerified: false,
      showBanner: false,
      showError: false,
    };
  },
  computed: {
    reviewToken(): string {
      return this.$route.params.reviewToken;
    },
    emailVerificationToken(): string {
      return this.$route.params.emailVerificationToken;
    },
  },
  mounted() {
    this.confirmEmail();
  },
  methods: {
    confirmEmail(): any {
      this.$apollo
        .mutate({
          mutation: CONFIRM_EMAIL_MUTATION,
          variables: {
            reviewToken: this.reviewToken,
            emailVerificationToken: this.emailVerificationToken,
          },
        })
        .then(() => {
          this.loading = false;
          this.emailVerified = true;
        })
        .catch((error) => {
          this.loading = false;

          if (error.graphQLErrors[0].message.includes('does not need email verification')) {
            this.emailVerified = true;
            this.showBanner = true;
          } else {
            this.emailVerified = false;
            this.showError = true;
            console.error(error);
          }
        });
    },
  },
};
</script>
